export const FETCH_LOOKS_WISHLIST = 'FETCH_LOOKS_WISHLIST';
export const FETCH_LOOKS_WISHLIST_SUCCESS = 'FETCH_LOOKS_WISHLIST_SUCCESS';
export const FETCH_LOOKS_WISHLIST_FAILED = 'FETCH_LOOKS_WISHLIST_FAILED';

export const ADD_TO_LOOKS_WISHLIST = 'ADD_TO_LOOKS_WISHLIST';
export const ADD_TO_LOOKS_WISHLIST_SUCCESS = 'ADD_TO_LOOKS_WISHLIST_SUCCESS';
export const ADD_TO_LOOKS_WISHLIST_FAILED = 'ADD_TO_LOOKS_WISHLIST_FAILED';

export const REMOVE_FROM_LOOKS_WISHLIST = 'REMOVE_FROM_LOOKS_WISHLIST';
export const REMOVE_FROM_LOOKS_WISHLIST_SUCCESS = 'REMOVE_FROM_LOOKS_WISHLIST_SUCCESS';
export const REMOVE_FROM_LOOKS_WISHLIST_FAILED = 'REMOVE_FROM_LOOKS_WISHLIST_FAILED';

export const LOOKS_WISHLIST_QUEUE_UPDATED = 'LOOKS_WISHLIST_QUEUE_UPDATED';
export const ADD_QUEUED_LOOK_TO_WISHLIST = 'ADD_QUEUED_LOOK_TO_WISHLIST';
export const REMOVE_QUEUED_LOOK_FROM_WISHLIST = 'REMOVE_QUEUED_LOOK_FROM_WISHLIST';

export interface LooksWishlistResponse {
    data?: Array<string>;
}

export interface LooksWishlistState {
    isFetching: boolean;
    didInvalidate: boolean;
    looks: Array<string>;
    count: number;
    error?: any;
}

export interface LooksWishlistQueueState {
    todo: 'ADD_QUEUED_LOOK_TO_WISHLIST' | 'REMOVE_QUEUED_LOOK_FROM_WISHLIST' | null;
    lookSlug: string | null;
}

export interface LooksWishlistQueueActionTypes {
    type: typeof LOOKS_WISHLIST_QUEUE_UPDATED;
    payload: LooksWishlistQueueState;
}
